import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface DeliverySettings {
  id: number;
  daily_target: number;
  weekly_target: number;
  monthly_target: number;
  otp_price_limit: number;
  ontime_delivery_fallback: number;
  max_capacity: number;
  created_at: string;
  updated_at?: string;
}

export interface DeliverySettingsApiResponse {
  success: boolean;
  message: string;
  data?: DeliverySettings;
}

export interface UpdateDeliverySettingsRequest {
  id: number;
  daily_target: number;
  weekly_target: number;
  monthly_target: number;
  otp_price_limit: number;
  ontime_delivery_fallback: number;
  max_capacity: number;
  created_at?: string;
}

export const DELIVERY_SETTINGS_API_CONFIG = {
  BASE_URL: process.env.REACT_APP_SERVER_ENDPOINT || 'https://fftestservice.sarsetech.com',
  AUTH_KEY: '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3',
  ENDPOINTS: {
    DELIVERY_LIST: '/admin/deliverysettings-list',
    DELIVERY_UPDATE: '/admin/deliverysettings-update',
  },
};

export const deliverySettingsApi = createApi({
  reducerPath: 'deliverySettingsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: DELIVERY_SETTINGS_API_CONFIG.BASE_URL,
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json');
      headers.set('authkey', DELIVERY_SETTINGS_API_CONFIG.AUTH_KEY);
      
      const token = localStorage.getItem('auth_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      
      return headers;
    },
  }),
  tagTypes: ['DeliverySettings'],
  endpoints: (build) => ({
    getDeliverySettings: build.query<DeliverySettingsApiResponse, void>({
      query: () => ({
        url: DELIVERY_SETTINGS_API_CONFIG.ENDPOINTS.DELIVERY_LIST,
        method: 'POST',
        body: JSON.stringify({ id: 1 }),
      }),
      providesTags: ['DeliverySettings'],
      transformResponse: (response: any) => {
        console.log('Delivery Settings List Response:', response);
        return {
          success: response.success || false,
          message: response.message || '',
          data: response.data,
        };
      },
    }),

    updateDeliverySettings: build.mutation<DeliverySettingsApiResponse, UpdateDeliverySettingsRequest>({
      query: (data) => {
        console.log('Update Delivery Settings Data:', data);
        
        const currentTimestamp = new Date().toISOString().replace('T', ' ').substring(0, 19);
        
        return {
          url: DELIVERY_SETTINGS_API_CONFIG.ENDPOINTS.DELIVERY_UPDATE,
          method: 'POST',
          body: JSON.stringify({
            id: data.id,
            daily_target: Number(data.daily_target),
            weekly_target: Number(data.weekly_target),
            monthly_target: Number(data.monthly_target),
            otp_price_limit: Number(data.otp_price_limit),
            ontime_delivery_fallback: Number(data.ontime_delivery_fallback),
            max_capacity: Number(data.max_capacity),
            created_at: data.created_at || currentTimestamp,
          }),
        };
      },
      invalidatesTags: ['DeliverySettings'],
      transformResponse: (response: any) => {
        console.log('Update Delivery Settings Response:', response);
        return {
          success: response.success || false,
          message: response.message || '',
        };
      },
      transformErrorResponse: (response: any) => {
        console.error('Update Delivery Settings Error:', response);
        return {
          status: response.status,
          data: response.data || { message: 'Unknown error occurred' }
        };
      },
    }),
  }),
});

export const {
  useGetDeliverySettingsQuery,
  useUpdateDeliverySettingsMutation,
} = deliverySettingsApi;